/* tslint:disable */
/* eslint-disable */
/**
 * 
 * Sparebank 1 Finans Midt-Norge API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'providerName': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'ownerName': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'ownerLegalId': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'ownerCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountType': AccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountStatus': AccountAccountStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'interestRate': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'effectiveRate': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'bookedBalance': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'availableBalance': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'pendingPayoutAmount': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'creditLimit': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'balanceDue': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'principalDate'?: string;
    /**
     * 
     * @type {Array<Entity>}
     * @memberof Account
     */
    'debtors'?: Array<Entity>;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'endDate'?: string;
}

export const AccountAccountTypeEnum = {
    Factoring: 'FACTORING',
    InvoiceSale: 'INVOICE_SALE',
    Leasing: 'LEASING',
    Loan: 'LOAN',
    Other: 'OTHER'
} as const;

export type AccountAccountTypeEnum = typeof AccountAccountTypeEnum[keyof typeof AccountAccountTypeEnum];
export const AccountAccountStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Suspended: 'SUSPENDED'
} as const;

export type AccountAccountStatusEnum = typeof AccountAccountStatusEnum[keyof typeof AccountAccountStatusEnum];

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'postalCode': number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine2': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine3': string;
}
/**
 * 
 * @export
 * @interface Agreement
 */
export interface Agreement {
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'legalId': string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'type': AgreementTypeEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Agreement
     */
    'metaData': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'createdBy'?: string;
}

export const AgreementTypeEnum = {
    Corporate: 'CORPORATE',
    Individual: 'INDIVIDUAL'
} as const;

export type AgreementTypeEnum = typeof AgreementTypeEnum[keyof typeof AgreementTypeEnum];

/**
 * 
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * 
     * @type {number}
     * @memberof ApiError
     */
    'httpStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'code': ApiErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiError
     */
    'errors': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'ref'?: string;
    /**
     * 
     * @type {ApiErrorCause}
     * @memberof ApiError
     */
    'cause'?: ApiErrorCause;
    /**
     * 
     * @type {Array<ApiErrorCauseStackTraceInner>}
     * @memberof ApiError
     */
    'stackTrace'?: Array<ApiErrorCauseStackTraceInner>;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ApiErrorCauseSuppressedInner>}
     * @memberof ApiError
     */
    'suppressed'?: Array<ApiErrorCauseSuppressedInner>;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'localizedMessage'?: string;
}

export const ApiErrorCodeEnum = {
    InsufficientPrivileges: 'InsufficientPrivileges',
    BadInput: 'BadInput',
    JsonError: 'JsonError',
    Unauthorized: 'Unauthorized',
    CustomerNotFound: 'CustomerNotFound',
    Unknown: 'Unknown'
} as const;

export type ApiErrorCodeEnum = typeof ApiErrorCodeEnum[keyof typeof ApiErrorCodeEnum];

/**
 * 
 * @export
 * @interface ApiErrorCause
 */
export interface ApiErrorCause {
    /**
     * 
     * @type {Array<ApiErrorCauseStackTraceInner>}
     * @memberof ApiErrorCause
     */
    'stackTrace'?: Array<ApiErrorCauseStackTraceInner>;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCause
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ApiErrorCauseSuppressedInner>}
     * @memberof ApiErrorCause
     */
    'suppressed'?: Array<ApiErrorCauseSuppressedInner>;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCause
     */
    'localizedMessage'?: string;
}
/**
 * 
 * @export
 * @interface ApiErrorCauseStackTraceInner
 */
export interface ApiErrorCauseStackTraceInner {
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'classLoaderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'moduleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'moduleVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'methodName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'lineNumber'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'nativeMethod'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseStackTraceInner
     */
    'className'?: string;
}
/**
 * 
 * @export
 * @interface ApiErrorCauseSuppressedInner
 */
export interface ApiErrorCauseSuppressedInner {
    /**
     * 
     * @type {Array<ApiErrorCauseStackTraceInner>}
     * @memberof ApiErrorCauseSuppressedInner
     */
    'stackTrace'?: Array<ApiErrorCauseStackTraceInner>;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseSuppressedInner
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorCauseSuppressedInner
     */
    'localizedMessage'?: string;
}
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'attachmentType': AttachmentAttachmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'fileName': string;
}

export const AttachmentAttachmentTypeEnum = {
    AgeDistributedBalanceList: 'AGE_DISTRIBUTED_BALANCE_LIST',
    InterimAccounts: 'INTERIM_ACCOUNTS',
    TaxReport: 'TAX_REPORT'
} as const;

export type AttachmentAttachmentTypeEnum = typeof AttachmentAttachmentTypeEnum[keyof typeof AttachmentAttachmentTypeEnum];

/**
 * 
 * @export
 * @interface AuthProviderResponse
 */
export interface AuthProviderResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthProviderResponse
     */
    'name': AuthProviderResponseNameEnum;
    /**
     * 
     * @type {string}
     * @memberof AuthProviderResponse
     */
    'loginUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthProviderResponse
     */
    'requiredMetaData': Array<string>;
}

export const AuthProviderResponseNameEnum = {
    MobileAuth: 'MOBILE_AUTH',
    Signicat: 'SIGNICAT',
    AzureAd: 'AZURE_AD',
    Internal: 'INTERNAL'
} as const;

export type AuthProviderResponseNameEnum = typeof AuthProviderResponseNameEnum[keyof typeof AuthProviderResponseNameEnum];

/**
 * 
 * @export
 * @interface BankConnection
 */
export interface BankConnection {
    /**
     * 
     * @type {string}
     * @memberof BankConnection
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BankConnection
     */
    'orgNo'?: string;
}
/**
 * 
 * @export
 * @interface CompanyInfo
 */
export interface CompanyInfo {
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    'bankAccount'?: string;
}
/**
 * 
 * @export
 * @interface ContactPerson
 */
export interface ContactPerson {
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface CustomerNotification
 */
export interface CustomerNotification {
    /**
     * 
     * @type {string}
     * @memberof CustomerNotification
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNotification
     */
    'type': CustomerNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerNotification
     */
    'channel': CustomerNotificationChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerNotification
     */
    'address': string;
}

export const CustomerNotificationTypeEnum = {
    OrderCreated: 'ORDER_CREATED'
} as const;

export type CustomerNotificationTypeEnum = typeof CustomerNotificationTypeEnum[keyof typeof CustomerNotificationTypeEnum];
export const CustomerNotificationChannelEnum = {
    Sms: 'SMS',
    Email: 'EMAIL'
} as const;

export type CustomerNotificationChannelEnum = typeof CustomerNotificationChannelEnum[keyof typeof CustomerNotificationChannelEnum];

/**
 * 
 * @export
 * @interface Debtor
 */
export interface Debtor {
    /**
     * 
     * @type {string}
     * @memberof Debtor
     */
    'orgNo': string;
}
/**
 * 
 * @export
 * @interface Entity
 */
export interface Entity {
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'legalId': string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'contactName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'contactEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'contactPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'phone': string;
    /**
     * 
     * @type {Address}
     * @memberof Entity
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface FinancedObject
 */
export interface FinancedObject {
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'productCategory'?: string;
    /**
     * 
     * @type {number}
     * @memberof FinancedObject
     */
    'productCategoryCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'productCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'gtin'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'merchantItemUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'productImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'serialNumber'?: string;
}
/**
 * 
 * @export
 * @interface Hook
 */
export interface Hook {
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface IncomingPayment
 */
export interface IncomingPayment {
    /**
     * 
     * @type {number}
     * @memberof IncomingPayment
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof IncomingPayment
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof IncomingPayment
     */
    'fees': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingPayment
     */
    'remainingBalance': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingPayment
     */
    'interest': number;
}
/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'initialInvoiceId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    'invoiceNo'?: number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'creditorRef'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'totalAmount': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'dueDate': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceDate': string;
    /**
     * 
     * @type {Entity}
     * @memberof Invoice
     */
    'debtor'?: Entity;
    /**
     * 
     * @type {Entity}
     * @memberof Invoice
     */
    'creditor'?: Entity;
    /**
     * 
     * @type {Array<string>}
     * @memberof Invoice
     */
    'comments': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'status': InvoiceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceSource': InvoiceInvoiceSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'cid': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'documentType': InvoiceDocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceDocumentUrl': string;
    /**
     * 
     * @type {Array<InvoiceLine>}
     * @memberof Invoice
     */
    'invoiceLines'?: Array<InvoiceLine>;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    'priceOffer'?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    'purchasePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'paymentStatus'?: InvoicePaymentStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    'isCreditNote': boolean;
}

export const InvoiceStatusEnum = {
    ProcessingFile: 'PROCESSING_FILE',
    PendingUpload: 'PENDING_UPLOAD',
    UploadedFlow: 'UPLOADED_FLOW',
    PendingApproval: 'PENDING_APPROVAL',
    Approved: 'APPROVED',
    Administered: 'ADMINISTERED',
    Rejected: 'REJECTED',
    Sold: 'SOLD',
    Error: 'ERROR',
    Cancelled: 'CANCELLED'
} as const;

export type InvoiceStatusEnum = typeof InvoiceStatusEnum[keyof typeof InvoiceStatusEnum];
export const InvoiceInvoiceSourceEnum = {
    Netbank: 'NETBANK',
    Erp: 'ERP',
    ManualSale: 'MANUAL_SALE'
} as const;

export type InvoiceInvoiceSourceEnum = typeof InvoiceInvoiceSourceEnum[keyof typeof InvoiceInvoiceSourceEnum];
export const InvoiceDocumentTypeEnum = {
    Ehf: 'EHF',
    Vipps: 'VIPPS',
    Einvoice: 'EINVOICE',
    Pdf: 'PDF',
    Mail: 'MAIL'
} as const;

export type InvoiceDocumentTypeEnum = typeof InvoiceDocumentTypeEnum[keyof typeof InvoiceDocumentTypeEnum];
export const InvoicePaymentStatusEnum = {
    Open: 'OPEN',
    Expired: 'EXPIRED',
    Paid: 'PAID',
    InCollection: 'IN_COLLECTION'
} as const;

export type InvoicePaymentStatusEnum = typeof InvoicePaymentStatusEnum[keyof typeof InvoicePaymentStatusEnum];

/**
 * 
 * @export
 * @interface InvoiceLine
 */
export interface InvoiceLine {
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    'lineNumber': number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'lineType': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'vat': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'amountIncVat': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'minAmountToPay': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    'termNo': number;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'authProvider': LoginRequestAuthProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'codeVerifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'redirectUri'?: string;
}

export const LoginRequestAuthProviderEnum = {
    MobileAuth: 'MOBILE_AUTH',
    Signicat: 'SIGNICAT',
    AzureAd: 'AZURE_AD',
    Internal: 'INTERNAL'
} as const;

export type LoginRequestAuthProviderEnum = typeof LoginRequestAuthProviderEnum[keyof typeof LoginRequestAuthProviderEnum];

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface OauthSession
 */
export interface OauthSession {
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'stage': OauthSessionStageEnum;
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'nextUri'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OauthSession
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OauthSession
     */
    'acr_values'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OauthSession
     */
    'requestedAudience'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof OauthSession
     */
    'canSkipConsent': boolean;
}

export const OauthSessionStageEnum = {
    Auth: 'AUTH',
    Consent: 'CONSENT',
    Redirect: 'REDIRECT'
} as const;

export type OauthSessionStageEnum = typeof OauthSessionStageEnum[keyof typeof OauthSessionStageEnum];

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'dealerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'externalId': string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'internalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderStatus': OrderOrderStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'orderFee'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderSource': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'cid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'reference': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'locale': string;
    /**
     * 
     * @type {Array<OrderAddress>}
     * @memberof Order
     */
    'coBuyers'?: Array<OrderAddress>;
    /**
     * 
     * @type {Array<OrderLine>}
     * @memberof Order
     */
    'orderLines': Array<OrderLine>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'riskAssessmentData'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'riskAssessmentDataType'?: string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalTaxAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalTaxRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'deliveryDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'paymentDueDate': string;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof Order
     */
    'paymentMethods': Array<PaymentMethod>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {Array<OrderAttachment>}
     * @memberof Order
     */
    'attachments': Array<OrderAttachment>;
    /**
     * 
     * @type {Array<CustomerNotification>}
     * @memberof Order
     */
    'customerNotifications': Array<CustomerNotification>;
    /**
     * 
     * @type {Array<Hook>}
     * @memberof Order
     */
    'hooks': Array<Hook>;
    /**
     * 
     * @type {OrderAddress}
     * @memberof Order
     */
    'billingAddress'?: OrderAddress;
    /**
     * 
     * @type {OrderAddress}
     * @memberof Order
     */
    'shippingAddress'?: OrderAddress;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'comments'?: string;
    /**
     * 
     * @type {Array<OrderLink>}
     * @memberof Order
     */
    'links'?: Array<OrderLink>;
}

export const OrderOrderStatusEnum = {
    New: 'NEW',
    Pending: 'PENDING',
    AwaitingTaxinfo: 'AWAITING_TAXINFO',
    TaxinfoReceived: 'TAXINFO_RECEIVED',
    AwaitingSignature: 'AWAITING_SIGNATURE',
    Cancelled: 'CANCELLED',
    Deleted: 'DELETED',
    Completed: 'COMPLETED',
    PaidInFull: 'PAID_IN_FULL',
    PaidInPart: 'PAID_IN_PART',
    SignatureComplete: 'SIGNATURE_COMPLETE',
    Rejected: 'REJECTED',
    Approved: 'APPROVED',
    PendingBackoffice: 'PENDING_BACKOFFICE'
} as const;

export type OrderOrderStatusEnum = typeof OrderOrderStatusEnum[keyof typeof OrderOrderStatusEnum];

/**
 * 
 * @export
 * @interface OrderAddress
 */
export interface OrderAddress {
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'legalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'companyType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'co'?: string;
}
/**
 * 
 * @export
 * @interface OrderAttachment
 */
export interface OrderAttachment {
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'contentExtension'?: string;
}
/**
 * 
 * @export
 * @interface OrderLine
 */
export interface OrderLine {
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'lineNumber': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'quantityUnits': string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'taxAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'taxRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'amountIncVat': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productCategory'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'productCategoryCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'environmentalImpact': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'gtin'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'merchantItemUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'serialNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'discountRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'discountAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface OrderLink
 */
export interface OrderLink {
    /**
     * 
     * @type {string}
     * @memberof OrderLink
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof OrderLink
     */
    'type': OrderLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderLink
     */
    'displayName': string;
}

export const OrderLinkTypeEnum = {
    Tos: 'TOS',
    Sbl: 'SBL'
} as const;

export type OrderLinkTypeEnum = typeof OrderLinkTypeEnum[keyof typeof OrderLinkTypeEnum];

/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'paymentType': PaymentMethodPaymentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    'invoiceSentByMerchant': boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'invoiceDocumentType'?: PaymentMethodInvoiceDocumentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'installments'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'initialPaymentAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'nominalInterestRate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    'fixedInterestRate'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'effectiveInterestRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'totalPaymentAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'totalPaymentAmountIncTax': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'installmentFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'installmentFeeInclTax'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'initialFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'initialFeeIncTax'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'residualValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'monthlyPaymentAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'accumulatedPaymentAmount'?: number;
}

export const PaymentMethodPaymentTypeEnum = {
    Leasing: 'LEASING',
    Subscription: 'SUBSCRIPTION',
    Downpayments: 'DOWNPAYMENTS',
    Invoice: 'INVOICE'
} as const;

export type PaymentMethodPaymentTypeEnum = typeof PaymentMethodPaymentTypeEnum[keyof typeof PaymentMethodPaymentTypeEnum];
export const PaymentMethodInvoiceDocumentTypeEnum = {
    Ehf: 'EHF',
    Vipps: 'VIPPS',
    Einvoice: 'EINVOICE',
    Pdf: 'PDF',
    Mail: 'MAIL'
} as const;

export type PaymentMethodInvoiceDocumentTypeEnum = typeof PaymentMethodInvoiceDocumentTypeEnum[keyof typeof PaymentMethodInvoiceDocumentTypeEnum];

/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'expectedCreditTime': number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'expectSoldAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'invoicesPerYear': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'productType': ProductProductTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'turnoverToCorporateCustomer': number;
}

export const ProductProductTypeEnum = {
    InvoiceSale: 'INVOICE_SALE',
    Leasing: 'LEASING',
    Loan: 'LOAN'
} as const;

export type ProductProductTypeEnum = typeof ProductProductTypeEnum[keyof typeof ProductProductTypeEnum];

/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'ssn': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'email': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Profile
     */
    'settings': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface SessionData
 */
export interface SessionData {
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'ssn'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'impersonatingUser'?: string;
    /**
     * 
     * @type {User}
     * @memberof SessionData
     */
    'user'?: User;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'ip': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'userAgent': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SessionData
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'loginDate': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'authLevel': SessionDataAuthLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'vendorContext'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'socialSecurityNumber'?: string;
}

export const SessionDataAuthLevelEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH'
} as const;

export type SessionDataAuthLevelEnum = typeof SessionDataAuthLevelEnum[keyof typeof SessionDataAuthLevelEnum];

/**
 * 
 * @export
 * @interface StartOnboardingRequest
 */
export interface StartOnboardingRequest {
    /**
     * 
     * @type {string}
     * @memberof StartOnboardingRequest
     */
    'legalId': string;
}
/**
 * 
 * @export
 * @interface StartOnboardingResponse
 */
export interface StartOnboardingResponse {
    /**
     * 
     * @type {number}
     * @memberof StartOnboardingResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof StartOnboardingResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof StartOnboardingResponse
     */
    'onboardingReference': string;
}
/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sourceSystemCode': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sourceApplicationID': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'transactionID': number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'transactionSource': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sourceTransactionID': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'accountNo': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'transactionType': TransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'bankAccountNo': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'paymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'cid': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Transaction
     */
    'comments': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'invoiceNo': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'transactionDate': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'vatAmount': number;
}

export const TransactionTransactionTypeEnum = {
    InvoicePurchase: 'INVOICE_PURCHASE',
    InvoiceFee: 'INVOICE_FEE',
    DocumentFee: 'DOCUMENT_FEE',
    Comission: 'COMISSION',
    Invoice: 'INVOICE',
    IncurredInterest: 'INCURRED_INTEREST',
    Recourse: 'RECOURSE',
    CreditNote: 'CREDIT_NOTE',
    Payment: 'PAYMENT',
    IncomingPayment: 'INCOMING_PAYMENT',
    InitialFee: 'INITIAL_FEE',
    Installment: 'INSTALLMENT',
    ExtraInstallment: 'EXTRA_INSTALLMENT',
    Other: 'OTHER'
} as const;

export type TransactionTransactionTypeEnum = typeof TransactionTransactionTypeEnum[keyof typeof TransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface UpdateOnboardingRequest
 */
export interface UpdateOnboardingRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateOnboardingRequest
     */
    'onboardingReference': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'onboardingStatus': UpdateOnboardingRequestOnboardingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'creditOnboardingSource': UpdateOnboardingRequestCreditOnboardingSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'dealerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'sellerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'customerType': UpdateOnboardingRequestCustomerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'invoicingCurrency'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'primaryDeliverables'?: UpdateOnboardingRequestPrimaryDeliverablesEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'invoicingType'?: UpdateOnboardingRequestInvoicingTypeEnum;
    /**
     * 
     * @type {Array<CompanyInfo>}
     * @memberof UpdateOnboardingRequest
     */
    'companyInfo': Array<CompanyInfo>;
    /**
     * 
     * @type {Array<BankConnection>}
     * @memberof UpdateOnboardingRequest
     */
    'bankConnection': Array<BankConnection>;
    /**
     * 
     * @type {Array<Debtor>}
     * @memberof UpdateOnboardingRequest
     */
    'primaryDebtors': Array<Debtor>;
    /**
     * 
     * @type {Array<ContactPerson>}
     * @memberof UpdateOnboardingRequest
     */
    'contactPerson': Array<ContactPerson>;
    /**
     * 
     * @type {Array<Product>}
     * @memberof UpdateOnboardingRequest
     */
    'products': Array<Product>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof UpdateOnboardingRequest
     */
    'attachments': Array<Attachment>;
}

export const UpdateOnboardingRequestOnboardingStatusEnum = {
    Pending: 'PENDING',
    Submitted: 'SUBMITTED',
    Rejected: 'REJECTED',
    Approved: 'APPROVED'
} as const;

export type UpdateOnboardingRequestOnboardingStatusEnum = typeof UpdateOnboardingRequestOnboardingStatusEnum[keyof typeof UpdateOnboardingRequestOnboardingStatusEnum];
export const UpdateOnboardingRequestCreditOnboardingSourceEnum = {
    Ownerbank: 'OWNERBANK',
    Notownerbank: 'NOTOWNERBANK'
} as const;

export type UpdateOnboardingRequestCreditOnboardingSourceEnum = typeof UpdateOnboardingRequestCreditOnboardingSourceEnum[keyof typeof UpdateOnboardingRequestCreditOnboardingSourceEnum];
export const UpdateOnboardingRequestCustomerTypeEnum = {
    Personal: 'PERSONAL',
    Corporate: 'CORPORATE'
} as const;

export type UpdateOnboardingRequestCustomerTypeEnum = typeof UpdateOnboardingRequestCustomerTypeEnum[keyof typeof UpdateOnboardingRequestCustomerTypeEnum];
export const UpdateOnboardingRequestPrimaryDeliverablesEnum = {
    Products: 'PRODUCTS',
    Projects: 'PROJECTS',
    Services: 'SERVICES',
    Other: 'OTHER'
} as const;

export type UpdateOnboardingRequestPrimaryDeliverablesEnum = typeof UpdateOnboardingRequestPrimaryDeliverablesEnum[keyof typeof UpdateOnboardingRequestPrimaryDeliverablesEnum];
export const UpdateOnboardingRequestInvoicingTypeEnum = {
    Advance: 'ADVANCE',
    Arrears: 'ARREARS',
    Both: 'BOTH',
    Null: 'NULL'
} as const;

export type UpdateOnboardingRequestInvoicingTypeEnum = typeof UpdateOnboardingRequestInvoicingTypeEnum[keyof typeof UpdateOnboardingRequestInvoicingTypeEnum];

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'legalId'?: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'customerNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'status': string;
    /**
     * 
     * @type {Array<UserIdentifier>}
     * @memberof User
     */
    'identifiers': Array<UserIdentifier>;
    /**
     * 
     * @type {Array<UserAddress>}
     * @memberof User
     */
    'addresses': Array<UserAddress>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface UserAddress
 */
export interface UserAddress {
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'addressLine2': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface UserIdentifier
 */
export interface UserIdentifier {
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'identifier': string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'type': UserIdentifierTypeEnum;
}

export const UserIdentifierTypeEnum = {
    Email: 'EMAIL',
    Ssn: 'SSN',
    Phone: 'PHONE',
    InternalId: 'INTERNAL_ID',
    SystemUser: 'SYSTEM_USER'
} as const;

export type UserIdentifierTypeEnum = typeof UserIdentifierTypeEnum[keyof typeof UserIdentifierTypeEnum];


/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change maturity date for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAccountMaturityDate: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('changeAccountMaturityDate', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('changeAccountMaturityDate', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/paymentplan`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment plan for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPaymentPlan: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getAccountPaymentPlan', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountPaymentPlan', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/paymentplan`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List related objects for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountObjects: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccountObjects', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAccountObjects', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/objects`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all transactions for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountTransactions: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccountTransactions', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAccountTransactions', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/transactions`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all accounts for a given user.
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccounts', 'agreementId', agreementId)
            const localVarPath = `/banking/{agreementId}/accounts`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all invoices for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listInvoices', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listInvoices', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/invoices`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request account termination. This operation will result in an invoice with due date 3 days from the current date. If the account is not settled by then, the account will return to normal state.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccountTermination: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('requestAccountTermination', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('requestAccountTermination', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/terminate`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change maturity date for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAccountMaturityDate(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IncomingPayment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAccountMaturityDate(agreementId, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment plan for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPaymentPlan(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IncomingPayment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPaymentPlan(agreementId, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List related objects for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountObjects(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancedObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountObjects(agreementId, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all transactions for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountTransactions(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Transaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountTransactions(agreementId, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all accounts for a given user.
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccounts(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Account>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccounts(agreementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all invoices for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoices(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invoice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoices(agreementId, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request account termination. This operation will result in an invoice with due date 3 days from the current date. If the account is not settled by then, the account will return to normal state.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccountTermination(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invoice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccountTermination(agreementId, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * 
         * @summary Change maturity date for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAccountMaturityDate(agreementId: string, accountId: string, options?: any): AxiosPromise<Array<IncomingPayment>> {
            return localVarFp.changeAccountMaturityDate(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment plan for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPaymentPlan(agreementId: string, accountId: string, options?: any): AxiosPromise<Array<IncomingPayment>> {
            return localVarFp.getAccountPaymentPlan(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List related objects for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountObjects(agreementId: string, accountId: string, options?: any): AxiosPromise<Array<FinancedObject>> {
            return localVarFp.listAccountObjects(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all transactions for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountTransactions(agreementId: string, accountId: string, options?: any): AxiosPromise<Array<Transaction>> {
            return localVarFp.listAccountTransactions(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all accounts for a given user.
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(agreementId: string, options?: any): AxiosPromise<Array<Account>> {
            return localVarFp.listAccounts(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all invoices for a given account.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices(agreementId: string, accountId: string, options?: any): AxiosPromise<Array<Invoice>> {
            return localVarFp.listInvoices(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request account termination. This operation will result in an invoice with due date 3 days from the current date. If the account is not settled by then, the account will return to normal state.
         * @param {string} agreementId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccountTermination(agreementId: string, accountId: string, options?: any): AxiosPromise<Invoice> {
            return localVarFp.requestAccountTermination(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * 
     * @summary Change maturity date for a given account.
     * @param {string} agreementId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public changeAccountMaturityDate(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).changeAccountMaturityDate(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment plan for a given account.
     * @param {string} agreementId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public getAccountPaymentPlan(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getAccountPaymentPlan(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List related objects for a given account.
     * @param {string} agreementId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccountObjects(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccountObjects(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all transactions for a given account.
     * @param {string} agreementId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccountTransactions(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccountTransactions(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all accounts for a given user.
     * @param {string} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccounts(agreementId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccounts(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all invoices for a given account.
     * @param {string} agreementId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listInvoices(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listInvoices(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request account termination. This operation will result in an invoice with due date 3 days from the current date. If the account is not settled by then, the account will return to normal state.
     * @param {string} agreementId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public requestAccountTermination(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).requestAccountTermination(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List available login providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoginProviders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login using token
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest?: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout user.
         * @param {Array<LoginRequest>} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (loginRequest?: Array<LoginRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List available login providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoginProviders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuthProviderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoginProviders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login using token
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest?: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout user.
         * @param {Array<LoginRequest>} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(loginRequest?: Array<LoginRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSession(options?: any): AxiosPromise<void> {
            return localVarFp.getCurrentSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List available login providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoginProviders(options?: any): AxiosPromise<Array<AuthProviderResponse>> {
            return localVarFp.listLoginProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login using token
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest?: LoginRequest, options?: any): AxiosPromise<SessionData> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout user.
         * @param {Array<LoginRequest>} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(loginRequest?: Array<LoginRequest>, options?: any): AxiosPromise<string> {
            return localVarFp.logout(loginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Get current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getCurrentSession(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getCurrentSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List available login providers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public listLoginProviders(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).listLoginProviders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login using token
     * @param {LoginRequest} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(loginRequest?: LoginRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout user.
     * @param {Array<LoginRequest>} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logout(loginRequest?: Array<LoginRequest>, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logout(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
         * @summary Check HTTP server status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAliveStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/alive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchant: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post auth token email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthTokenEmail: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/token/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post login sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLoginSso: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/login/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
         * @summary Check HTTP server status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAliveStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAliveStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchant(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post auth token email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAuthTokenEmail(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAuthTokenEmail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post login sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLoginSso(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLoginSso(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
         * @summary Check HTTP server status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAliveStatus(options?: any): AxiosPromise<void> {
            return localVarFp.checkAliveStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchant(options?: any): AxiosPromise<void> {
            return localVarFp.getMerchant(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post auth token email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthTokenEmail(options?: any): AxiosPromise<void> {
            return localVarFp.postAuthTokenEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post login sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLoginSso(options?: any): AxiosPromise<void> {
            return localVarFp.postLoginSso(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
     * @summary Check HTTP server status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAliveStatus(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAliveStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchant(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post auth token email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAuthTokenEmail(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAuthTokenEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post login sso
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postLoginSso(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postLoginSso(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a letter in pdf format.
         * @summary Get a letter
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageFile: async (messageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessageFile', 'messageId', messageId)
            const localVarPath = `/message/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Messages are sent from our customer support and may include interest rate letters, price changes etc.
         * @summary List personal messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a letter in pdf format.
         * @summary Get a letter
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageFile(messageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageFile(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Messages are sent from our customer support and may include interest rate letters, price changes etc.
         * @summary List personal messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessages(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessages(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * Returns a letter in pdf format.
         * @summary Get a letter
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageFile(messageId: string, options?: any): AxiosPromise<Array<Message>> {
            return localVarFp.getMessageFile(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Messages are sent from our customer support and may include interest rate letters, price changes etc.
         * @summary List personal messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages(options?: any): AxiosPromise<Array<Message>> {
            return localVarFp.listMessages(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * Returns a letter in pdf format.
     * @summary Get a letter
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessageFile(messageId: string, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessageFile(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Messages are sent from our customer support and may include interest rate letters, price changes etc.
     * @summary List personal messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public listMessages(options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).listMessages(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OauthApi - axios parameter creator
 * @export
 */
export const OauthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept consent challenge.
         * @param {string} [consentChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsentChallenge: async (consentChallenge?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (consentChallenge !== undefined) {
                localVarQueryParameter['consentChallenge'] = consentChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept login challenge.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptLoginChallenge: async (loginChallenge?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loginChallenge !== undefined) {
                localVarQueryParameter['loginChallenge'] = loginChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a pending oauth session.
         * @summary Get oauth session.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthSession: async (loginChallenge?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loginChallenge !== undefined) {
                localVarQueryParameter['loginChallenge'] = loginChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OauthApi - functional programming interface
 * @export
 */
export const OauthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OauthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept consent challenge.
         * @param {string} [consentChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptConsentChallenge(consentChallenge?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptConsentChallenge(consentChallenge, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Accept login challenge.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptLoginChallenge(loginChallenge?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptLoginChallenge(loginChallenge, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a pending oauth session.
         * @summary Get oauth session.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOauthSession(loginChallenge?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOauthSession(loginChallenge, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OauthApi - factory interface
 * @export
 */
export const OauthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OauthApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept consent challenge.
         * @param {string} [consentChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsentChallenge(consentChallenge?: string, options?: any): AxiosPromise<OauthSession> {
            return localVarFp.acceptConsentChallenge(consentChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept login challenge.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptLoginChallenge(loginChallenge?: string, options?: any): AxiosPromise<OauthSession> {
            return localVarFp.acceptLoginChallenge(loginChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a pending oauth session.
         * @summary Get oauth session.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthSession(loginChallenge?: string, options?: any): AxiosPromise<OauthSession> {
            return localVarFp.getOauthSession(loginChallenge, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OauthApi - object-oriented interface
 * @export
 * @class OauthApi
 * @extends {BaseAPI}
 */
export class OauthApi extends BaseAPI {
    /**
     * 
     * @summary Accept consent challenge.
     * @param {string} [consentChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public acceptConsentChallenge(consentChallenge?: string, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).acceptConsentChallenge(consentChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept login challenge.
     * @param {string} [loginChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public acceptLoginChallenge(loginChallenge?: string, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).acceptLoginChallenge(loginChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a pending oauth session.
     * @summary Get oauth session.
     * @param {string} [loginChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public getOauthSession(loginChallenge?: string, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).getOauthSession(loginChallenge, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Start onboarding of new merchant.
         * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOnboarding: async (startOnboardingResponse?: Array<StartOnboardingResponse>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startOnboardingResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update onboarding of new merchant.
         * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboarding: async (updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOnboardingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Start onboarding of new merchant.
         * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startOnboarding(startOnboardingResponse?: Array<StartOnboardingResponse>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartOnboardingRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startOnboarding(startOnboardingResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update onboarding of new merchant.
         * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnboarding(updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOnboardingRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOnboarding(updateOnboardingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * 
         * @summary Start onboarding of new merchant.
         * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOnboarding(startOnboardingResponse?: Array<StartOnboardingResponse>, options?: any): AxiosPromise<StartOnboardingRequest> {
            return localVarFp.startOnboarding(startOnboardingResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update onboarding of new merchant.
         * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboarding(updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options?: any): AxiosPromise<UpdateOnboardingRequest> {
            return localVarFp.updateOnboarding(updateOnboardingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * 
     * @summary Start onboarding of new merchant.
     * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public startOnboarding(startOnboardingResponse?: Array<StartOnboardingResponse>, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).startOnboarding(startOnboardingResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update onboarding of new merchant.
     * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateOnboarding(updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateOnboarding(updateOnboardingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options?: any): AxiosPromise<Profile> {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Get user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getProfile(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VendorsApi - axios parameter creator
 * @export
 */
export const VendorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculate the price of an order with a given payment method.
         * @summary Calculate the price of an order.
         * @param {string} agreementId Agreement for which we will calculate the order price.
         * @param {Order} order Order object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderPrice: async (agreementId: string, order: Order, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('calculateOrderPrice', 'agreementId', agreementId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('calculateOrderPrice', 'order', order)
            const localVarPath = `/vendors/{agreementId}/orders/calculate`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel an order in our system.
         * @summary Cancel an order.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (agreementId: string, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('cancelOrder', 'agreementId', agreementId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelOrder', 'orderId', orderId)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}/cancel`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new order in our system.
         * @summary Create a new order.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {Order} order Order object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (agreementId: string, order: Order, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('createOrder', 'agreementId', agreementId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('createOrder', 'order', order)
            const localVarPath = `/vendors/{agreementId}/orders`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get report for defined date interval for a given account.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
         * @param {string} [toDate] Report interval end date. Defaults to end of current month.
         * @param {string} [type] Report type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: async (agreementId: string, fromDate?: string, toDate?: string, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getReport', 'agreementId', agreementId)
            const localVarPath = `/vendors/{agreementId}/reports`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An agreement represents a customer\'s bank connection. Organizations might have several agreements
         * @summary List all orders that are accessible to the logged-in user.
         * @param {string} agreementId 
         * @param {string} [fromDate] Only show orders updated after the given date. Should be empty if fromUpdateDate is set.
         * @param {string} [toDate] Only show orders updated before the given date. Should be empty if toUpdateDate is set.
         * @param {string} [fromUpdateDate] Only show orders updated after the given date. Should be empty if fromDate is set.
         * @param {string} [toUpdateDate] Only show orders updated before the given date. Should be empty if toDate is set.
         * @param {number} [maxCount] Maximum numbers of orders in response.
         * @param {string} [nextPageToken] Pagination token. Must be added to subsequent request. See documentation for more info.
         * @param {string} [statuses] Comma separated list of statuses. Only cases with a status matching the list will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: async (agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listOrders', 'agreementId', agreementId)
            const localVarPath = `/vendors/{agreementId}/orders`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (fromUpdateDate !== undefined) {
                localVarQueryParameter['fromUpdateDate'] = fromUpdateDate;
            }

            if (toUpdateDate !== undefined) {
                localVarQueryParameter['toUpdateDate'] = toUpdateDate;
            }

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all accounts that are accessible to the logged-in user.
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVendorAccounts: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listVendorAccounts', 'agreementId', agreementId)
            const localVarPath = `/vendors/{agreementId}/accounts`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An agreement represents a customer\'s bank connection. Organizations might have several agreements
         * @summary List all agreements that are accessible to the logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVendors: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorsApi - functional programming interface
 * @export
 */
export const VendorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculate the price of an order with a given payment method.
         * @summary Calculate the price of an order.
         * @param {string} agreementId Agreement for which we will calculate the order price.
         * @param {Order} order Order object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOrderPrice(agreementId: string, order: Order, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOrderPrice(agreementId, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancel an order in our system.
         * @summary Cancel an order.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(agreementId: string, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(agreementId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new order in our system.
         * @summary Create a new order.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {Order} order Order object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(agreementId: string, order: Order, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(agreementId, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get report for defined date interval for a given account.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
         * @param {string} [toDate] Report interval end date. Defaults to end of current month.
         * @param {string} [type] Report type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReport(agreementId: string, fromDate?: string, toDate?: string, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(agreementId, fromDate, toDate, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * An agreement represents a customer\'s bank connection. Organizations might have several agreements
         * @summary List all orders that are accessible to the logged-in user.
         * @param {string} agreementId 
         * @param {string} [fromDate] Only show orders updated after the given date. Should be empty if fromUpdateDate is set.
         * @param {string} [toDate] Only show orders updated before the given date. Should be empty if toUpdateDate is set.
         * @param {string} [fromUpdateDate] Only show orders updated after the given date. Should be empty if fromDate is set.
         * @param {string} [toUpdateDate] Only show orders updated before the given date. Should be empty if toDate is set.
         * @param {number} [maxCount] Maximum numbers of orders in response.
         * @param {string} [nextPageToken] Pagination token. Must be added to subsequent request. See documentation for more info.
         * @param {string} [statuses] Comma separated list of statuses. Only cases with a status matching the list will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrders(agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Order>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrders(agreementId, fromDate, toDate, fromUpdateDate, toUpdateDate, maxCount, nextPageToken, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all accounts that are accessible to the logged-in user.
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVendorAccounts(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Account>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVendorAccounts(agreementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * An agreement represents a customer\'s bank connection. Organizations might have several agreements
         * @summary List all agreements that are accessible to the logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVendors(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVendors(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VendorsApi - factory interface
 * @export
 */
export const VendorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorsApiFp(configuration)
    return {
        /**
         * Calculate the price of an order with a given payment method.
         * @summary Calculate the price of an order.
         * @param {string} agreementId Agreement for which we will calculate the order price.
         * @param {Order} order Order object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderPrice(agreementId: string, order: Order, options?: any): AxiosPromise<Order> {
            return localVarFp.calculateOrderPrice(agreementId, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel an order in our system.
         * @summary Cancel an order.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(agreementId: string, orderId: string, options?: any): AxiosPromise<Order> {
            return localVarFp.cancelOrder(agreementId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new order in our system.
         * @summary Create a new order.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {Order} order Order object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(agreementId: string, order: Order, options?: any): AxiosPromise<Order> {
            return localVarFp.createOrder(agreementId, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get report for defined date interval for a given account.
         * @param {string} agreementId Agreement to fetch report for.
         * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
         * @param {string} [toDate] Report interval end date. Defaults to end of current month.
         * @param {string} [type] Report type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(agreementId: string, fromDate?: string, toDate?: string, type?: string, options?: any): AxiosPromise<any> {
            return localVarFp.getReport(agreementId, fromDate, toDate, type, options).then((request) => request(axios, basePath));
        },
        /**
         * An agreement represents a customer\'s bank connection. Organizations might have several agreements
         * @summary List all orders that are accessible to the logged-in user.
         * @param {string} agreementId 
         * @param {string} [fromDate] Only show orders updated after the given date. Should be empty if fromUpdateDate is set.
         * @param {string} [toDate] Only show orders updated before the given date. Should be empty if toUpdateDate is set.
         * @param {string} [fromUpdateDate] Only show orders updated after the given date. Should be empty if fromDate is set.
         * @param {string} [toUpdateDate] Only show orders updated before the given date. Should be empty if toDate is set.
         * @param {number} [maxCount] Maximum numbers of orders in response.
         * @param {string} [nextPageToken] Pagination token. Must be added to subsequent request. See documentation for more info.
         * @param {string} [statuses] Comma separated list of statuses. Only cases with a status matching the list will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders(agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options?: any): AxiosPromise<Array<Order>> {
            return localVarFp.listOrders(agreementId, fromDate, toDate, fromUpdateDate, toUpdateDate, maxCount, nextPageToken, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all accounts that are accessible to the logged-in user.
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVendorAccounts(agreementId: string, options?: any): AxiosPromise<Array<Account>> {
            return localVarFp.listVendorAccounts(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * An agreement represents a customer\'s bank connection. Organizations might have several agreements
         * @summary List all agreements that are accessible to the logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVendors(options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.listVendors(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendorsApi - object-oriented interface
 * @export
 * @class VendorsApi
 * @extends {BaseAPI}
 */
export class VendorsApi extends BaseAPI {
    /**
     * Calculate the price of an order with a given payment method.
     * @summary Calculate the price of an order.
     * @param {string} agreementId Agreement for which we will calculate the order price.
     * @param {Order} order Order object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public calculateOrderPrice(agreementId: string, order: Order, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).calculateOrderPrice(agreementId, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel an order in our system.
     * @summary Cancel an order.
     * @param {string} agreementId Agreement to fetch report for.
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public cancelOrder(agreementId: string, orderId: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).cancelOrder(agreementId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new order in our system.
     * @summary Create a new order.
     * @param {string} agreementId Agreement to fetch report for.
     * @param {Order} order Order object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public createOrder(agreementId: string, order: Order, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).createOrder(agreementId, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get report for defined date interval for a given account.
     * @param {string} agreementId Agreement to fetch report for.
     * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
     * @param {string} [toDate] Report interval end date. Defaults to end of current month.
     * @param {string} [type] Report type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public getReport(agreementId: string, fromDate?: string, toDate?: string, type?: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).getReport(agreementId, fromDate, toDate, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An agreement represents a customer\'s bank connection. Organizations might have several agreements
     * @summary List all orders that are accessible to the logged-in user.
     * @param {string} agreementId 
     * @param {string} [fromDate] Only show orders updated after the given date. Should be empty if fromUpdateDate is set.
     * @param {string} [toDate] Only show orders updated before the given date. Should be empty if toUpdateDate is set.
     * @param {string} [fromUpdateDate] Only show orders updated after the given date. Should be empty if fromDate is set.
     * @param {string} [toUpdateDate] Only show orders updated before the given date. Should be empty if toDate is set.
     * @param {number} [maxCount] Maximum numbers of orders in response.
     * @param {string} [nextPageToken] Pagination token. Must be added to subsequent request. See documentation for more info.
     * @param {string} [statuses] Comma separated list of statuses. Only cases with a status matching the list will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public listOrders(agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).listOrders(agreementId, fromDate, toDate, fromUpdateDate, toUpdateDate, maxCount, nextPageToken, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all accounts that are accessible to the logged-in user.
     * @param {string} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public listVendorAccounts(agreementId: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).listVendorAccounts(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An agreement represents a customer\'s bank connection. Organizations might have several agreements
     * @summary List all agreements that are accessible to the logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public listVendors(options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).listVendors(options).then((request) => request(this.axios, this.basePath));
    }
}


